/**
 * Styled Components - Created by eduardoquinterp on 19/08/20.
 */
import styled from 'styled-components'
import { WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface DivProps {
  active?: boolean,
  darkMode?: boolean
}

export const Text = styled.div`
  color: ${WHITE};
`

export const Image = styled.img`
  cursor: pointer;
  width: 20px;
  border-radius: 50%;
  transition: all .25s;
  opacity: ${({ active }: DivProps) => active ? 0.4 : 1};
`

export const BellIcon = styled(Icon)`
  color: ${({ darkMode }: DivProps) => darkMode ? WHITE : 'black'};
  opacity: ${({ active }: DivProps) => active ? 0.4 : 1};
  font-size: 18px;
  cursor: pointer;
  @media (max-width: 1099px) {
    font-size: 16px;
  }
`

export const NotificationList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: scroll;
  width: 100%;
`

export const Empty = styled.div`
  padding: 25px;
`

export const overlayStyle = {
  maxWidth: '386px',
  width: '100%'
}

export const overlayMobileStyle = {
  width: '100%',
  zIndex: 1000
}

export const ActionLabel = styled.div`
  margin: 6px 14px 4px;
  color: #529cf0;
  font-size: 14px;
  text-align: end;
  user-select: none;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.4;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/NotificationHeader/styledComponents.tsx